import React from 'react';
import CommonButton from '../../Components/CommonButton';
import { T } from './Text';

export default function ErrorRow({ message, onRetry }) {
    return (
        <div role="alert" className="nova_error">
            <T size="md" className="nova_error_text">{message}</T>
            {onRetry && <CommonButton variant="white" className="nova_btn nova_btn--sm" text="Retry" onClick={onRetry} />}
        </div>
    );
}
